<div class="notes-dialog-container" *transloco="let t">
	<h1 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">{{ t('billing.notes') }}</h1>

	<mat-dialog-content>
		<p class="subtitle">{{ t('billing.forBillingPeriod') }} {{ subtitle }}</p>

		<div #notesList class="notes-list" [class.loading]="loading()">
			@if (loading()) {
				<ng-container>
					<div class="spinner-style">
						<mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
					</div>
				</ng-container>
			}

			@for (note of notes(); track note.exportId) {
				<div class="note-item">
					<div class="flex flex-row">
						<div class="flex-grow flex flex-col">
							<mat-form-field
								appearance="outline"
								[class.is-readonly]="
									editingNoteExportId() !== note.exportId || period().customerAccessStatus !== CustomerAccessStatus.ACTIVATED
								">
								<textarea
									matInput
									cdkTextareaAutosize
									cdkAutosizeMinRows="1"
									cdkAutosizeMaxRows="4"
									[(ngModel)]="note.text"
									[readonly]="editingNoteExportId() !== note.exportId || period().customerAccessStatus !== CustomerAccessStatus.ACTIVATED"
									[tabIndex]="editingNoteExportId() === note.exportId ? 0 : -1"
									[maxlength]="NOTES_TEXT_MAXLENGTH"
									class="note-textarea"></textarea>
							</mat-form-field>
						</div>

						<div class="actions flex flex-col">
							@if (period().customerAccessStatus === CustomerAccessStatus.ACTIVATED) {
								@if (editingNoteExportId() !== note.exportId) {
									<button
										mat-icon-button
										color="primary"
										[matTooltip]="t('commonActions.edit')"
										(click)="unlockNote(note)"
										[disabled]="editingNoteExportId() !== null">
										<mat-icon>edit</mat-icon>
									</button>
								} @else {
									<button mat-icon-button color="primary" [matTooltip]="t('commonActions.cancel')" (click)="lockNote(note)">
										<mat-icon>cancel</mat-icon>
									</button>
								}
								@if (editingNoteExportId() !== note.exportId) {
									<button mat-icon-button color="warn" [matTooltip]="t('commonActions.delete')" (click)="deleteNote(note)">
										<mat-icon>delete</mat-icon>
									</button>
								} @else {
									<button
										mat-icon-button
										color="primary"
										[matTooltip]="t('commonActions.save')"
										(click)="saveNote(note)"
										[disabled]="note.text?.length === 0">
										<mat-icon>save</mat-icon>
									</button>
								}
							}
						</div>
					</div>
					@if (editingNoteExportId() === note.exportId) {
						<div class="char-counter flex flex-row">{{ note.text?.length || 0 }}/{{ NOTES_TEXT_MAXLENGTH }} {{ t('common.characters') }}</div>
					}
				</div>
			}

			@if (!notes().length && !loading()) {
				<div class="flex flex-col items-center justify-center py-8 text-gray-400">
					<mat-icon class="text-4xl h-12 w-12 mb-2">event_note</mat-icon>
					<p>{{ t('billing.noNotesAvailable') }}</p>
				</div>
			}
		</div>
	</mat-dialog-content>

	<mat-dialog-actions align="end" class="p-4 gap-2">
		<button mat-button (click)="close()">{{ t('commonActions.close') }}</button>
		@if (period().customerAccessStatus === CustomerAccessStatus.ACTIVATED) {
			<button mat-raised-button color="primary" (click)="addNote()" [disabled]="editingNoteExportId() !== null">
				<mat-icon>add</mat-icon>
				{{ t('billing.newNote') }}
			</button>
		}
	</mat-dialog-actions>
</div>
